import { render, staticRenderFns } from "./login-recuperar-error.vue?vue&type=template&id=63b397fa&scoped=true&"
import script from "./login-recuperar-error.vue?vue&type=script&lang=ts&"
export * from "./login-recuperar-error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b397fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
